{
  "R": [255, 255],
  "G": [255, 11],
  "B": [0, 0],
  "A": [0, 64],
  "I": [0, 255]
}
